<template>
    <div class="typerelease">
        <b-row>
            <b-col md="10" sm="12">
                <PageTitle
                    icon="fa fa-clone"
                    main="Registro"
                    sub="Tipo de Lançamento"
                />
            </b-col>
        </b-row>
        <b-form
            v-show="mode === 'save' || mode === 'remove' || mode === 'read'"
        >
            <input id="typerelease-id" type="hidden" v-model="typerelease.id" />
            <b-row>
                <b-col md="7" sm="12">
                    <b-form-group
                        label="Nome:"
                        label-for="typerelease-name_type_release"
                    >
                        <b-form-input
                            id="typerelease-name_type_release"
                            type="text"
                            ref="searchFocus"
                            v-model="typerelease.name_type_release"
                            size="sm"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            placeholder="Nome..."
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="1" sm="2">
                    <b-form-group label="ID" label-for="entity-id">
                        <b-form-input
                            id="entity-id"
                            type="text"
                            title="ALT+ENTER (PESQUISAR)"
                            v-model="typerelease.entity_id"
                            @input="setEntity()"
                            @change="setEntity()"
                            v-on:keyup.alt.enter="openModalEntity"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            ref="inputFist"
                            size="sm"
                            placeholder="Código..."
                        />
                    </b-form-group>
                </b-col>
                <b-link
                    v-b-modal.modalEntity
                    class="fa fa-search mt-4"
                ></b-link>
                <b-col md="4" sm="8">
                    <b-form-group
                        label="Razão Social:"
                        label-for="entity-name_entity"
                    >
                        <b-form-input
                            id="entity-name_entity"
                            type="text"
                            v-model="entity.name_entity"
                            size="sm"
                            :readonly="true"
                            placeholder="Razão Social..."
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="2">
                    <b-form-group label="CPF/CNPJ:" label-for="entity-cnpj_cpf">
                        <b-form-input
                            id="entity-cnpj_cpf"
                            type="text"
                            v-model="entity.cnpj_cpf"
                            size="sm"
                            :readonly="true"
                            placeholder=""
                        />
                    </b-form-group>
                </b-col>
                <b-link v-b-modal.modalRegisterEntity class="fa fa-plus mt-4">
                </b-link>
            </b-row>
            <b-row>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Valor Máximo:"
                        label-for="typerelease-maximum_value"
                    >
                        <b-form-input
                            id="typerelease-maximum_value"
                            v-model="typerelease.maximum_value"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            type="number"
                            size="sm"
                            step="0.02"
                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3" sm="12">
                    <b-form-group
                        label="Condição de Pagamento/Recebimento:"
                        label-for="typerelease-condition_payment_receipt_id"
                    >
                        <b-form-select
                            id="typerelease-condition_payment_receipt_id"
                            :disabled="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            size="sm"
                            :options="conditionpaymentreceipts"
                            v-model="typerelease.condition_payment_receipt_id"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3" sm="12">
                    <b-form-group
                        label="Forma de Pagamento/Recebimento:"
                        label-for="typerelease-settlement_form_id"
                    >
                        <b-form-select
                            id="typerelease-settlement_form_id"
                            :disabled="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            size="sm"
                            :options="settlementforms"
                            v-model="typerelease.settlement_form_id"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="typerelease.blocked"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="typerelease-blocked"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="typerelease-blocked"
                            >
                                Bloqueado?
                            </label>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Operação:"
                        label-for="typerelease-operation_type_id"
                    >
                        <b-form-select
                            id="typerelease-operation_type_id"
                            size="sm"
                            :disabled="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            :options="operations"
                            v-model="typerelease.operation_type_id"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3" sm="12">
                    <b-form-group
                        label="Tipo de Documento:"
                        label-for="typerelease-type_document_id"
                    >
                        <b-form-select
                            id="typerelease-type_document_id"
                            :disabled="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            size="sm"
                            :options="typedocuments"
                            v-model="typerelease.type_document_id"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group
                        label="Conta Banco/Caixa:"
                        label-for="typerelease-entity_settlement_id"
                    >
                        <b-form-select
                            id="typerelease-entity_settlement_id"
                            size="sm"
                            :disabled="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            :options="entitysettlements"
                            v-model="typerelease.entity_settlement_id"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>

        <hr v-show="mode === 'save'" />
        <b-row>
            <b-col xs="12">
                <b-button
                    size="sm"
                    variant="dark"
                    class="mt-2  mb-2 fa fa-plus"
                    v-show="mode !== 'save' && mode !== 'remove'"
                    @click="alterModo"
                >
                </b-button>
                <b-button
                    size="sm"
                    variant="dark"
                    class="mt-2 mb-2 ml-2 fa fa-save"
                    v-if="mode === 'save'"
                    @click="save"
                >
                </b-button>
                <b-button
                    size="sm"
                    variant="dark"
                    class="mt-2 mb-2 ml-2 fa fa-trash"
                    v-if="mode === 'remove'"
                    @click="remove"
                >
                </b-button>
                <b-button
                    size="sm"
                    btn-sm
                    variant="dark"
                    class="mt-2 mb-2 ml-2 fa fa-reply"
                    v-if="
                        mode === 'remove' || mode === 'save' || mode === 'read'
                    "
                    @click="reset"
                >
                </b-button>
                <b-button
                    size="sm"
                    class="mt-2 mb-2 ml-2 fa"
                    :class="icon"
                    @click="
                        ;[
                            loadTypeReleases(),
                            toggleBusy(),
                            (showTable = !showTable),
                        ]
                    "
                    variant="dark"
                >
                </b-button>
            </b-col>
        </b-row>
        <br />
        <div class="col-sm-4">
            <div class="form-group">
                <input
                    type="text"
                    size="sm"
                    icon="search"
                    v-model="search"
                    ref="searchFocus"
                    v-show="mode !== 'save' && mode !== 'remove'"
                    placeholder="Informe a descrição"
                    class="form-control"
                />
            </div>
        </div>
        <b-row>
            <transition name="slide" type="animation" appear>
                <b-table
                    :busy="isBusy"
                    class="table-responsive"
                    v-show="mode !== 'save' && mode !== 'remove'"
                    hover
                    key="slide"
                    head-variant="light"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :items="filteredList"
                    :fields="fields"
                >
                    <template v-slot:table-busy>
                        <div class="text-center text-info my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Carregando...</strong>
                        </div>
                    </template>
                    <template v-slot:cell(actions)="data">
                        <b-button
                            title="Detalhe do registro"
                            size="sm"
                            variant="light"
                            @click="loadTypeRelease(data.item, 'read')"
                            class="mr-2 mt-2"
                        >
                            <i class="fa fa-drivers-license-o"></i>
                        </b-button>
                        <b-button
                            title="Editar registro"
                            size="sm"
                            variant="light"
                            @click="loadTypeRelease(data.item)"
                            class="mr-2 mt-2"
                        >
                            <i class="fa fa-pencil"></i>
                        </b-button>
                        <b-button
                            title="Excluir registro"
                            size="sm"
                            variant="light"
                            @click="loadTypeRelease(data.item, 'remove')"
                            class="mr-2 mt-2"
                        >
                            <i class="fa fa-trash"></i>
                        </b-button>
                    </template>
                    <template v-slot:cell(accesses)="data">
                        <b-button
                            title="Complemento do registro"
                            size="sm"
                            variant="light"
                            @click="actionTypeRelease(data.item)"
                            class="mr-2 mt-2"
                        >
                            <i class="fa fa-external-link"></i>
                        </b-button>
                    </template>
                </b-table>
            </transition>
            <transition name="slide" type="animation" appear>
                <b-pagination
                    v-show="mode !== 'save' && mode !== 'remove'"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                ></b-pagination>
            </transition>
        </b-row>

        <b-modal
            id="modalEntity"
            ref="modal"
            title-tag="h6"
            size="lg"
            title="Consulta de Cliente/Fornecedor"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="setSearchEntity"
        >
            <EntitySearchModal
                @setEntityId="entity_id = $event"
                @setEntityName="entity.name_entity = $event"
                @setEntityCnpjCpf="entity.cnpj_cpf = $event"
            />
        </b-modal>
        <b-modal
            id="modalRegisterEntity"
            hide-footer
            ref="modal"
            size="xl"
            title-tag="h6"
            title="Registro de Cliente/Fornecedor"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <EntityModal />
        </b-modal>
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
import EntityModal from '../util/EntityModal'
import EntitySearchModal from '../util/EntitySearchModal'
var moment = require('moment-timezone')

export default {
    name: 'TypeRelease',
    components: { PageTitle, EntityModal, EntitySearchModal },
    data: function() {
        return {
            mode: 'insert',
            modeRelease: 'insert',
            setCompany: false,
            isBusy: false,
            CompanyName: '',
            search: '',
            searchEntity: '',
            typerelease: {},
            typereleases: [],
            operations: [],
            entity: {},
            entitys: [],
            entitysshearch: [],
            entity_id: null,
            typedocuments: [],
            entitysettlements: [],
            release: {},
            releases: [],
            conditionpaymentreceipts: [],
            settlementforms: [],
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            footerBgVariant: 'warning',
            footerTextVariant: 'dark',
            showTable: false,
            perPage: 5,
            currentPage: 1,
            fields: [
                { key: 'name_type_release', label: 'Nome', sortable: true },
                { key: 'cnpj_cpf', label: 'CPF/CNPJ', sortable: false },
                { key: 'name_entity', label: 'Razão Social', sortable: false },
                { key: 'name_operation', label: 'Operação', sortable: false },
                { key: 'actions', label: 'Ações', variant: 'light' },
                { key: 'accesses', label: 'Acessos', variant: 'secondary' },
            ],
            fieldsRelease: [
                {
                    key: 'name_type_release',
                    label: 'Tipo',
                    sortable: true,
                    variant: 'secondary',
                },
                { key: 'name_entity', label: 'Nome', sortable: false },
                {
                    key: 'issue_date',
                    label: 'Data',
                    sortable: false,
                    formatter: value =>
                        value ? moment(value).format('DD-MM-YYYY') : '',
                },
                { key: 'release_value', label: 'Valor', sortable: false },
                { key: 'actions', label: 'Ações', variant: 'light' },
            ],
            fieldsEntity: [
                { key: 'id', label: 'Código', sortable: true },
                { key: 'name_entity', label: 'Nome', sortable: true },
                { key: 'cnpj_cpf', label: 'CPF/CNPJ', sortable: false },
                {
                    key: 'blocked',
                    label: 'Bloqueado',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não'),
                },
                { key: 'actions', label: 'Ações' },
            ],
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        compan() {
            return this.$store.state.compan
        },
        filteredList() {
            return this.typereleases.filter(typerelease => {
                return typerelease.name_type_release
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
            })
        },
        filteredListEntity() {
            return this.entitysshearch.filter(entity => {
                return entity.name_entity
                    .toLowerCase()
                    .includes(this.searchEntity.toLowerCase())
            })
        },
        icon() {
            return this.showTable ? 'fa-retweet' : 'fa-search'
        },
        rows() {
            return this.typereleases.length
        },
    },
    methods: {
        formatDate(date) {
            return moment.utc(date).format('YYYY-MM-DD')
        },
        toggleBusy() {
            this.isBusy = !this.isBusy
        },
        async loadTypeReleases() {
            if (!this.compan) {
                this.$toasted.global.defaultWarnig({ msg: 'Logar na Empresa' })
            } else {
                const url = `${baseApiUrl}/typereleasesbycompany/${this.compan.id}`
                await axios.get(url).then(res => {
                    this.typereleases = res.data
                    this.isBusy = false
                })
            }
        },
        loadEntitys() {
            const url = `${baseApiUrl}/entitys`
            axios.get(url).then(res => {
                this.entitysshearch = res.data
            })
        },
        loadTypeRelease(typerelease, mode = 'save') {
            this.mode = mode
            this.typerelease = { ...typerelease }
        },
        reset() {
            this.mode = 'insert'
            this.loadTypeReleases()
        },
        alterModo() {
            this.mode = 'save'
            this.typerelease = {}
        },
        async save() {
            if (this.typerelease.id) {
                this.typerelease.user_update_id = this.user.id
                this.typerelease.update_date = this.formatDate(moment.utc())
            } else {
                this.typerelease.user_id = this.user.id
                this.typerelease.company_id = this.compan.id
            }

            const method = this.typerelease.id ? 'put' : 'post'
            const id = this.typerelease.id ? `/${this.typerelease.id}` : ''
            await axios[method](
                `${baseApiUrl}/typereleases${id}`,
                this.typerelease
            )
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        async remove() {
            const id = this.typerelease.id
            await axios
                .delete(`${baseApiUrl}/typereleases/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        loadEntity() {
            const url = `${baseApiUrl}/entitys`
            axios.get(url).then(res => {
                this.entitys = res.data.map(entity => {
                    return {
                        value: entity.id,
                        text: ` ${entity.name_entity} - ${entity.cnpj_cpf} `,
                    }
                })
            })
        },
        async loadEntitySettlements() {
            const url = `${baseApiUrl}/entitysettement/${this.compan.id}`
            await axios.get(url).then(res => {
                this.entitysettlements = res.data.map(entitysettlement => {
                    return {
                        value: entitysettlement.id,
                        text: `${entitysettlement.name_entity} - ${entitysettlement.cnpj_cpf}`,
                    }
                })
            })
        },
        loadTypeDocument() {
            const url = `${baseApiUrl}/typedocuments`
            axios.get(url).then(res => {
                this.typedocuments = res.data.map(typedocument => {
                    return {
                        value: typedocument.id,
                        text: typedocument.name_reduced,
                    }
                })
            })
        },
        loadConditionPaymentReceipt() {
            const url = `${baseApiUrl}/conditionpaymentreceipts`
            axios.get(url).then(res => {
                this.conditionpaymentreceipts = res.data.map(
                    conditionpaymentreceipt => {
                        return {
                            value: conditionpaymentreceipt.id,
                            text:
                                conditionpaymentreceipt.name_condition_payment_receipt,
                        }
                    }
                )
            })
        },
        loadOperation() {
            const url = `${baseApiUrl}/operations`
            axios.get(url).then(res => {
                this.operations = res.data.map(operation => {
                    return {
                        value: operation.id,
                        text: operation.name_operation,
                    }
                })
            })
        },

        async loadSettlementForms() {
            const url = `${baseApiUrl}/settlementforms`
            await axios.get(url).then(res => {
                this.settlementforms = res.data.map(settlementform => {
                    return {
                        value: settlementform.id,
                        text: settlementform.name_settlement_form,
                    }
                })
            })
        },
        async setEntity(entity) {
            if (!this.typerelease.entity_id) {
                this.typerelease.entity_id = entity.id
            }
            const url = `${baseApiUrl}/entitys/${this.typerelease.entity_id}`
            await axios(url).then(res => (this.entity = res.data))
        },
        actionTypeRelease(typerelease) {
            this.$router.push({
                name: 'RecordTypeRelease',
                params: { id: typerelease.id },
            })
        },
        setSearchEntity() {
            this.typerelease = {
                ...this.typerelease,
                entity_id: this.entity_id,
            }
        },
    },
    mounted() {
        this.loadTypeReleases()
        this.loadEntity()
        this.loadOperation()
        this.loadTypeDocument()
        this.loadConditionPaymentReceipt()
        this.loadSettlementForms()
        this.loadEntitySettlements()
        this.showTable = true
    },
}
</script>

<style>
.typerelease {
    font-size: 0.75rem;
}

.typerelease input,
label,
form {
    font-size: 0.75rem;
}
.typerelease button {
    font-size: 0.75rem;
}

.typerelease select {
    font-size: 0.75rem;
}

.typerelease table {
    font-size: 0.75rem;
}

#modalRelease {
    font-size: 0.75rem;
}

#modalRelease input,
label,
form {
    font-size: 0.75rem;
}

#modalRelease button {
    font-size: 0.75rem;
}

#modalRelease table {
    font-size: 0.75rem;
}

#modalRelease select {
    font-size: 0.75rem;
}

@keyframes slide-in {
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(40px);
    }
}

.slide-enter-active {
    animation: slide-in 1s ease;
    transition: opacity 1s;
}

.slide-leave-active {
    animation: slide-out 1s ease;
    transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
</style>
